<template>
  <ul class="divide-y divide-gray-200">
    <template v-if="loading" >
      <li v-for="i in 4" class="py-4 flex space-x-3">
        <div class="shrink-0 flex items-center justify-center w-10 h-10 bg-gray-300 text-white text-sm leading-5 font-medium rounded-md">
        </div>      <div class="flex flex-col w-full">
        <loading width="w-2/3" height="h-8" class="mb-4"></loading>
        <loading width="w-1/2" height="h-4"></loading>
      </div>
      </li>
    </template>

    <template v-if="!loading">
      <li v-for="(myUser, index) in users" :key="myUser.id" class="py-4 flex space-x-3">
        <div :class="backgroundColorArray[index]"
             class="shrink-0 flex items-center justify-center w-10 h-10 text-white text-sm leading-5 font-medium rounded-md">
          {{ myUser.initials }}
        </div>
        <div class="flex flex-col">
          <span class="text-sm leading-5 font-medium text-gray-900 mb-2">
            {{ myUser.display_name }}
            <span v-if="myUser.notification_enabled === 0"
                  class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-yellow-100 text-yellow-800">
              Notifications are not enabled for this user
            </span>
            <span v-if="myUser.via_group === true"
                  class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-green-100 text-green-800">
              Group Alarming
            </span>
          </span>
          <span class="text-sm leading-5 text-gray-500 flex w-full justify-between">
            <span v-if="myUser.sms > 0" class="lnr icon-smartphone-notification"></span>
            <span v-if="myUser.voice > 0" class="lnr icon-phone-wave"></span>
            <span v-if="myUser.email > 0" class="lnr icon-envelope"></span>
            <span v-if="myUser.push > 0" class="lnr icon-cloud-alert"></span>
          </span>
        </div>
      </li>
      <div v-if="Object.keys(users).length === 0">No users are set to receive alarms on this point.</div>
    </template>

  </ul>
</template>

<script>
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import axios from "axios";
import Loading from "@/components/elements/loading";

export default {
  name: "zoneUsersNotificationMethods",
  components: {Loading},
  mixins: [ SonicuCoreMixin ],
  props: {
    zoneId: {
      type: [Number, String],
      required: true,
    }
  },
  data(){
    return {
      users: null,
      loading: true,
      lastNumber: 0,
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData(){
      axios.get(this.company.buildCompanyApiInternalRoute('zones/' + this.zoneId + '/alarm-notification-methods')).then(
          response => {
            this.users = response.data;
            this.loading = false
          }
      ).catch(
          error => {

          }
      )
    },
    randomIntFromInterval(min, max) { // min and max included
      return Math.floor(Math.random() * (max - min + 1) + min);
    }
  },
  computed: {
    backgroundColorArray(){
      let colorObject = {
        1: 'bg-red-600',
        2: 'bg-green-600',
        3: 'bg-orange-600',
        4: 'bg-purple-600',
        5: 'bg-pink-600',
        6: 'bg-blue-600',
      }
      let resultObject = {}
      if(typeof this.users === 'object' && this.users !== 'null'){
        let i = 1;
        for(let key in Object.keys(this.users)){
          resultObject[key] = colorObject[i];
          i++;
          if(i > 6){
            i = 1;
          }
        }
      }
      return resultObject;
    }
  }
}
</script>

<style scoped>

</style>